import React from 'react';

import Divider from 'components/shared/others/divider/divider';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';

import CurrentUserProfile from 'containers/admin/profile/profile';
import SecurityHub from 'containers/user/profile/components/security-hub/security-hub';

import { useSessionFreshnessPing } from 'hooks/use-session-freshness-ping';

import { useCurrentUser } from 'hooks/api/use-current-user';

const Profile = (): React.JSX.Element => {
  const currentUser = useCurrentUser();

  useSessionFreshnessPing();

  return (
    <ResponsiveWrapper>
      <CurrentUserProfile />
      {!currentUser.data?.superAdmin && (
        <>
          <Divider />
          <SecurityHub />
        </>
      )}
    </ResponsiveWrapper>
  );
};

export default Profile;
